import { render, staticRenderFns } from "./FriendsButton.vue?vue&type=template&id=4e674d50"
import script from "./FriendsButton.vue?vue&type=script&lang=js"
export * from "./FriendsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports